<script>
import Container from '@/components/Container'

export default {
  name: 'Tile',
  props: {
    tile: { required: true, type: Object },
    record: { required: true, type: Object }
  },
  components: {
    Container
  },
  watch: {
    tile: {
      deep: true,
      handler: function() {
        this.resizeFont()
      }
    },
    record: {
      deep: true,
      handler: function() {
        this.resizeFont()
      }
    }
  },
  computed: {
    sizerDiv: function() {
      return document.querySelector(`#tileSizerDiv_${this.tile.key}`)
    },
    contentDiv: function() {
      return document.querySelector(
        `#tileResultContainer_${this.tile.key} .containerContent`
      )
    }
  },
  methods: {
    resizeFont(down) {
      if (down) {
        this.sizerDiv.innerText = this.contentDiv.innerText
        this.sizerDiv.style.fontSize = window.getComputedStyle(
          this.contentDiv
        ).fontSize
        if (this.sizerDiv.offsetWidth > this.contentDiv.offsetWidth - 20) {
          this.contentDiv.style.fontSize =
            parseInt(
              window
                .getComputedStyle(this.contentDiv)
                .fontSize.replace('px', '')
            ) -
            5 +
            'px'
          this.resizeFont(true)
        }
      } else if (!this.$slots.content) {
        this.contentDiv.style.lineHeight =
          this.contentDiv.offsetHeight - 25 + 'px'
        this.contentDiv.style.fontSize =
          this.contentDiv.offsetHeight - 25 + 'px'
        this.resizeFont(true)
      }
    }
  },
  mounted() {
    setTimeout(this.resizeFont, 1) // make sure the modal is shown for saved reports
  }
}
</script>

<template>
  <div>
    <div class="sizer-div" :id="`tileSizerDiv_${tile.key}`"></div>
    <Container
      class="tile-container"
      :collapsable="false"
      :id="`tileResultContainer_${tile.key}`"
    >
      <template v-slot:header>{{ getLabel(tile) }}</template>
      <template v-slot:content>
        <slot name="content">{{
          tile.type == 'boolean'
            ? record[tile.key]
              ? 'Yes'
              : 'No'
            : typeof record[tile.key] == 'number'
            ? record[tile.key].toLocaleString('en-US')
            : record[tile.key]
        }}</slot>
      </template>
    </Container>
  </div>
</template>

<style>
.sizer-div {
  display: inline-block;
  width: max-content !important;
  height: 0px;
  visibility: hidden;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 0;
}
.sizer-div,
.tile-container .containerContent,
.tile-container .containerHeader .sectionHeaderTitle {
  white-space: nowrap;
  text-align: center;
  width: 100%;
  min-width: max-content !important;
}
.sizer-div,
.tile-container .containerContent {
  font-size: 30px;
  display: block;
  height: 100%;
  min-height: 100px;
  font-weight: bold;
}
</style>
